import { useState, useEffect } from "react";
import CookieSettingsPanel from "./CookieSettingsPanel";
import { Cookie } from "lucide-react";
import clarity from "@microsoft/clarity";

export default function CookieSettingsButton() {
    const [open, setOpen] = useState(false);
    const [accepted, setAccepted] = useState(false);
    const [consent, setConsent] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const adminFlag = localStorage.getItem("is_admin") === "true";
        setIsAdmin(adminFlag);
        // amikor a komponens betölt → megnézzük, elfogadta-e már
        const stored = sessionStorage.getItem("cookie_consent");

        if (stored) {
            setAccepted(true);
            setConsent(JSON.parse(stored));   // ← FONTOS!
        }

        // event listener, hogy CookieConsent komponensből is lehessen jelezni
        const handler = () => {
            const latest = sessionStorage.getItem("cookie_consent");
            if (latest) {
                setAccepted(true);
                setConsent(JSON.parse(latest));  // ← LEGFontosabb!
            }
        };

        window.addEventListener("cookieAccepted", handler);

        return () => {
            window.removeEventListener("cookieAccepted", handler);
        };
    }, []);

    // 🔥 FACEBOOK PIXEL INIT
    useEffect(() => {
        if (!consent?.marketing) return;

        // ha már betöltött, ne töltsük újra
        if (window.fbq) return;

        // betöltés
        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
            if (!f._fbq) f._fbq = n;
            n.push = n; n.loaded = !0; n.version = '2.0';
            n.queue = []; t = b.createElement(e); t.async = !0;
            t.src = v; s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        })(
            window,
            document,
            'script',
            'https://connect.facebook.net/en_US/fbevents.js'
        );

        fbq('init', process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID);
        fbq('track', 'PageView');

    }, [consent]);

    // 🔥 GOOGLE ANALYTICS INIT
    useEffect(() => {
        if (!consent?.analytics) return;

        const gaId = process.env.NEXT_PUBLIC_GA_ID;
        if (!gaId) return;

        if (window.__ga_inited) return;
        window.__ga_inited = true;

        window.dataLayer = window.dataLayer || [];
        window.gtag = window.gtag || function () {
            window.dataLayer.push(arguments);
        };

        if (!document.getElementById("ga-script")) {
            const script = document.createElement("script");
            script.id = "ga-script";
            script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
            script.async = true;
            document.head.appendChild(script);
        }

        window.gtag("js", new Date());
        window.gtag("config", gaId);
    }, [consent]);


    // 🔥 MICROSOFT CLARITY INIT
    useEffect(() => {
        if (process.env.NODE_ENV !== "production") {
            console.log("[Clarity] effect fired", {
                consent,
                analytics: consent?.analytics,
                pid: process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID,
                hasWindowClarity: typeof window !== "undefined" && !!window.clarity,
            });
        }

        if (!consent?.analytics) {
            if (process.env.NODE_ENV !== "production") {
                console.log("[Clarity] skip: consent.analytics is false/undefined");
            }
            return;
        }

        const pid = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;
        if (!pid) {
            if (process.env.NODE_ENV !== "production") {
                console.log("[Clarity] skip: NEXT_PUBLIC_CLARITY_PROJECT_ID is missing");
            }
            return;
        }

        if (typeof window === "undefined") {
            if (process.env.NODE_ENV !== "production") {
                console.log("[Clarity] skip: not in browser");
            }
            return;
        }

        if (window.clarity) {
            if (process.env.NODE_ENV !== "production") {
                console.log("[Clarity] skip: already initialized (window.clarity exists)");
            }
            return;
        }

        if (process.env.NODE_ENV !== "production") {
            console.log("[Clarity] init()", pid);
        }

        clarity.init(pid);

        if (process.env.NODE_ENV !== "production") {
            setTimeout(() => {
                console.log("[Clarity] after init", {
                    typeOfWindowClarity: typeof window.clarity,
                    hasWindowClarity: !!window.clarity,
                });
            }, 500);
        }
    }, [consent]);


    if (!accepted && !isAdmin) return null;

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="fixed bottom-4 left-4 z-[9998] bg-black text-white p-3 rounded-full shadow-lg cursor-pointer"
            >
                <Cookie />
            </button>

            <CookieSettingsPanel open={open} onClose={() => setOpen(false)} />
        </>
    );
}
